<template>
  <div class="chart-rents-started-by-type">
    <div class="thumbnail" style="margin-bottom: 0">
      <loading v-if="!chartOptions"/>
      <highcharts v-else :options="chartOptions" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'ChartRentsStartedByType',
    components: {},
    data () {
      return {
        chartOptions: false
      }
    },
    computed: {
      apiDomain () {
        return config.apiDomain
      },
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        this.loadRentsStartedByType({ companyId: this.user.company.id })
        .then((response) => {
          this.chartOptions = {
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              height: 300,
              type: 'pie'
            },
            title: {
              text: 'Locações na situação <b>iniciadas</b> neste momento'
            },
            subtitle: {
              text: 'Locações agrupadas por tipo de período'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'default',
                dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.y} = {point.percentage:.1f} %'
                }
              }
            },
            series: [{
              name: 'Quantidade',
              colorByPoint: true,
              data: response.data
            }],
            credits: {
              style: {
                color: '#fff'
              }
            }
          }
        }, (error) => {
          console.log(error)
        })
      },
      ...mapActions(['loadRentsStartedByType'])
    }
  }
</script>


// WEBPACK FOOTER //
// ChartRentsStartedByType.vue?89678e48